// Redux action types
export const SET = 'one-state-patient-global-search/set';
export const ADD = 'one-state-patient-global-search/add';
export const SPIN = 'one-state-patient-global-search/spin';
export const SEARCH = 'one-state-patient-global-search/search';
export const REINIT = 'one-state-patient-global-search/reinit';
